import { render, staticRenderFns } from "./WorkspaceUsersCard.vue?vue&type=template&id=4e331e22&scoped=true&"
import script from "./WorkspaceUsersCard.vue?vue&type=script&lang=js&"
export * from "./WorkspaceUsersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e331e22",
  null
  
)

export default component.exports